import { RefObject, useEffect, useRef } from "react";

const useClickOutside = (ref: RefObject<HTMLElement>, onClickOutside: () => void): void => {
  // Stored in a ref so the effect never needs to re-run when the callback changes.
  const callbackRef = useRef(onClickOutside);
  callbackRef.current = onClickOutside;

  useEffect(() => {
    const handleClick = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        callbackRef.current();
      }
    };
    document.addEventListener("mousedown", handleClick);
    return () => document.removeEventListener("mousedown", handleClick);
  }, [ref]);
};

export default useClickOutside;
